import { invoke } from "@tauri-apps/api/core";

import { useDictation } from "./use-dictation";
import { useVoiceAttentionStore } from "./voice-attention-store";
import {
  activateVoiceAttentionNative,
  clearVoiceAttentionSessionEverywhere,
  startVoiceAttentionSession,
  voiceAttentionOriginDisplayId,
} from "./voice-attention-session";

let recordingId: string | null = null;

export function beginDictationAttention(): void {
  recordingId = startVoiceAttentionSession();
}

export async function activateDictationAttentionCapture(): Promise<void> {
  if (!recordingId) return;
  await activateVoiceAttentionNative(recordingId).catch(() => {});
}

/** The attention session the last dictation began, until it ends. */
export function dictationAttentionRecordingId(): string | null {
  return recordingId;
}

/**
 * Ends attention session `id`: its strokes, captures and overlay in every
 * window, and the native draw session (`set_voice_active`), so the gesture
 * tap never outlives the recording. A stale id never ends a newer session
 * or touches the native one, and a live Denker recording keeps its native
 * session. An anywhere recording is ended by its own flow, even before its
 * final settles the status.
 */
export function endDictationAttention(id: string | null): void {
  if (!id) return;
  const live =
    recordingId === id || useVoiceAttentionStore.getState().recordingId === id;
  if (recordingId === id) recordingId = null;
  clearVoiceAttentionSessionEverywhere(id);
  const { status, mode } = useDictation.getState();
  if (live && (status !== "recording" || mode === "anywhere")) {
    void invoke("set_voice_active", { active: false }).catch(() => {});
  }
}

export function clearDictationAttention(): void {
  endDictationAttention(
    recordingId ?? useVoiceAttentionStore.getState().recordingId,
  );
}

export function dictationAttentionOriginDisplayId(): number | null {
  return voiceAttentionOriginDisplayId();
}
